// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a8e80548","732":"d5e985b8","977":"5b53aeaa"}[chunkId] + ".chunk.js";
};